export const style = (theme) => ({
  root: {
    width: "100%",
    height: "100%",
  },
  listItem: {
    position: "relative",
    width: "150px",
    cursor: "pointer",
    height: "150px",
    margin: "8px 16px 8px 0",
    boxShadow:
      "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
    // width : '100%',
    //  height: "100%",
    //  boxShadow:
    //    "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    //  position: "relative",
  },
  imageItem: {
    minHeight: "8rem",
    width: "100%",
    cursor: "pointer",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  inputImage: {
    display: "none",
  },
  buttonIcon: {
    width: 64,
    height: 64,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
  icon: {
    cursor: "pointer",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: 60,
    color: "rgb(204, 204, 204)",
  },
  buttonHover: {
    width: 36,
    height: 36,
    margin: "0px 5px",
  },
  container: {
    display: "flex",
    flexFlow: "row",
    flexWrap: "wrap",
  },
});
